import { forwardRef } from 'react';
import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';

export type CheckboxProps = MuiCheckboxProps;

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ color = 'primary', ...rest }, ref) => <MuiCheckbox ref={ref} color={color} {...rest} />
);

Checkbox.displayName = 'Checkbox';
